export interface Faq {
  question: string
  answer: string
}
export const faqs: Faq[] = [
  {
    question: 'Jak działa plan semestru?',
    answer:
      'Jest podzielony na 16 tygodni. Każdy tydzień pokazuje temat do przerobienia, ćwiczenie do wydrukowania dla każdego poziomu, stronę z teorią do wyjaśnienia i zadanie domowe. Możesz zacząć w dowolnym momencie: tydzień 1 to Twoja pierwsza lekcja.',
  },
  {
    question: 'Mam uczniów na bardzo różnych poziomach. Czy to zadziała?',
    answer:
      'Tak, właśnie po to powstał. Plan ma 3 ścieżki (początkujący, średniozaawansowany, wyzwanie), które co tydzień przerabiają ten sam temat, każda na swoim poziomie.',
  },
  {
    question: 'Czy to produkt cyfrowy czy fizyczny?',
    answer:
      'W pełni cyfrowy. Cała zawartość jest w formacie PDF — na razie nie ma filmów. Dostęp natychmiastowy, a wydrukować możesz wszystko, co chcesz.',
  },
  {
    question: 'Czy muszę być specjalistą od jazzu, żeby z tego uczyć?',
    answer:
      'Nie. Większość korzystających nauczycieli wywodzi się z gitary rockowej, popowej lub klasycznej. Każda sesja mówi Ci, co wyjaśnić, w jakiej kolejności i na co zwracać uwagę, dzięki czemu jesteś zawsze o krok przed uczniem, ucząc się materiału razem z nim.',
  },
  {
    question: 'Czy to sprawdzi się na poziomie moich uczniów?',
    answer:
      'Tak. System obejmuje wszystko — od absolutnych początków po poziom zaawansowany. Wszystkie materiały są modułowe i łatwe do dostosowania.',
  },
  {
    question: 'Czy mogę dostosować lekcje do moich uczniów?',
    answer:
      'Oczywiście. Każdą lekcję można edytować — została zaprojektowana tak, by dopasować ją do Twojego kontekstu nauczania.',
  },
  {
    question: 'Jak uzyskam dostęp do materiałów?',
    answer:
      'Natychmiastowe pobranie PDF po zakupie. Wszystko trafia na Twój e-mail w ciągu 2 minut.',
  },
  {
    question: 'Co jeśli nie będę w pełni zadowolony?',
    answer:
      'Napisz do supportu w ciągu 10 dni od zakupu, a zwrócimy całą kwotę. Wszystkie pobrane pliki zostają u Ciebie.',
  },
]
